import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: toast?.POSITION?.TOP_RIGHT,
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};
const notifySuccess = (message) => {
  toast.success(message, toastOptions);
};
let debouncerTimer;
let hasShownError = false;
// const notifyError = (message) => {
//   console.log(debouncerTimer, "debouncerTimer", hasShownError);
//   if (hasShownError) return;
//   hasShownError = true;
//   if (debouncerTimer) clearTimeout(debouncerTimer);
//   debouncerTimer = setTimeout(() => {
//     toast.error(message, toastOptions);
//     hasShownError = false;
//   }, 300);
// };
const notifyError = (() => {
  let activeToast = null;
  return (message) => {
    if (activeToast) return;
    activeToast = toast.error(message, {
      ...toastOptions,
      onClose: () => {
        activeToast = null;
      },
    });
  };
})();

const notifyInfo = (message) => {
  toast.info(message, toastOptions);
};

const notifyWarning = (message) => {
  toast.warn(message, toastOptions);
};

const handleError = (payload) => {
  let message;
  switch (payload.status) {
    case 400:
      message = "Bad Request. Please check your input.";
      break;
    case 401:
      message = "Unauthorized. Please log in.";
      break;
    case 403:
      message = "Forbidden. You do not have permission to perform this action.";
      break;
    case 404:
      message = "Not Found. The requested resource could not be found.";
      break;
    case 409:
      message =
        "Conflict. This request could not be processed due to a conflict.";
      break;
    case 500:
      message = "Internal Server Error. Please try again later.";
      break;
    default:
      message = "An unexpected error occurred. Please try again.";
  }
  notifyError(message);
};

export { notifySuccess, notifyError, notifyInfo, notifyWarning };
